import { isPaperOrOnboarding } from "~/v2/utils";
import { useGetCurrentAccountIfLiveElseTradingAccount } from "./useGetAccount";
import { useGetBillingOverview } from "./useGetBillingOverview";
import { useGetElitePerks } from "./useGetElitePerks";

export const useGetIsSubscribedToMarketData = () => {
  const { account } = useGetCurrentAccountIfLiveElseTradingAccount();

  const { perks: elitePerks, isLoading: isElitePerksLoading } =
    useGetElitePerks({
      accountID: account?.id ?? "",
      options: {
        enabled: !!account?.id && !isPaperOrOnboarding(account),
      },
    });

  const { billing, isLoading: isBillingLoading } = useGetBillingOverview({
    options: {
      enabled: !!account?.id,
    },
  });

  const isSubscribed = !!billing?.plan || !!elitePerks?.market_data;

  const isLoading = !account || isElitePerksLoading || isBillingLoading;

  return {
    isSubscribed,
    isLoading,
  };
};
